function getColmunsNew({ t }) {

  const valueType = {
    AZURE_ONLINE: t('form.condition_rules.AZURE_ONLINE'),
    AZURE_COM: t('form.condition_rules.AZURE_COM'),
    AZURE_ENABLE: t('form.condition_rules.AZURE_ENABLE'),
    SD_OK: t('form.condition_rules.SD_OK'),
    MODBUS_COM: t('form.condition_rules.MODBUS_COM'),
    UPDATED_TIME: t('form.condition_rules.UPDATED_TIME'),
    EXTRTC_OK: t('form.condition_rules.EXTRTC_OK'),
    UPDATING: t('form.condition_rules.UPDATING'),
    UPDATE_OK: t('form.condition_rules.UPDATE_OK'),
    HAS_CONN_STRn: t('form.condition_rules.HAS_CONN_STR'),
    INTERNET_CONNECTIONn: t('form.condition_rules.INTERNET_CONNECTION'),
    RESET_EVENTn: t('form.condition_rules.RESET_EVENT'),
    RESERVED: t('form.condition_rules.RESERVED'),
  };

  const columns = [
    {
      width: '25%',
      title: t('box.notificationInverter.table.level'),
      dataIndex: 'label',
    },
    {
      width: '25%',
      title: t('box.notificationInverter.table.name'),
      dataIndex: 'name',
    },
    {
      width: '50%',
      title: t('box.notificationInverter.table.description'),
      dataIndex: 'name',
      render: (_, record) => valueType[record.name],
    },
  ];
  return columns;

}

export default getColmunsNew;
